// src/utils/payment.js

const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const sendViaVenmo = (amount, note, recipientUsername, agreementID) => {
  const username = recipientUsername ? recipientUsername.replace(/^@/, '') : '';
  const returnUrl = agreementID ? encodeURIComponent(`https://www.tuttoclaro.com/#/agreement-confirmed/${agreementID}?from=venmo`) : '';

  if (isMobile() && username) {
    // Try native Venmo app
    const venmoUrl = `venmo://paycharge?txn=pay&recipients=${username}&amount=${amount}&note=${encodeURIComponent(note)}${returnUrl ? `&redirect_url=${returnUrl}` : ''}`;
    window.location.href = venmoUrl;
    // Fallback to web after delay
    setTimeout(() => {
      window.open(`https://venmo.com/${username}?txn=pay&amount=${amount}&note=${encodeURIComponent(note)}`, '_blank');
    }, 1500);
  } else if (username) {
    window.open(`https://venmo.com/${username}?txn=pay&amount=${amount}&note=${encodeURIComponent(note)}`, '_blank');
  } else {
    window.open(`https://venmo.com/?txn=pay&amount=${amount}&note=${encodeURIComponent(note)}`, '_blank');
  }
};

export const openZelleBank = (bank, zelleId, agreementID) => {
  const returnUrl = `https://www.tuttoclaro.com/#/agreement-confirmed/${agreementID}?from=zelle`;
  if (bank === 'chase') {
    window.location.href = `https://www.chase.com/personal/mobile-banking`;
  } else if (bank === 'bofa') {
    window.location.href = `https://www.bankofamerica.com/online-banking/mobile-and-online-banking-features/money-transfer/zelle/`;
  }
  // After opening bank, set a flag so we can prompt on return
  sessionStorage.setItem('zellePaymentPending', agreementID);
};

export const buildShareMessage = (title, agreementID, baseURL) => {
  const link = `${baseURL}/#/confirm/${agreementID}`;
  return `Please confirm or decline this agreement: ${title}\n\nLink: ${link}\n\nAgreement ID: ${agreementID}`;
};

export const buildWhatsAppURL = (message) => {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
};
